import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components/macro'
import { media } from 'ui/rwd'
import { theme } from 'styled-tools'
import { Button, Label as LabelBase } from 'reactstrap'
import { MdCheck } from 'react-icons/md'

const RequestAccessWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 7;
  position: absolute;
  top: 230px;
  width: 320px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  ${media.sm`
    top: 430px;
  `};
`
const RequestAccessTitle = styled.div`
  font-weight: 900;
  color: white;
  text-align: center;
  letter-spacing: 1px;
  font-size: 27px;
  ${media.sm`
    letter-spacing: 2px;
    font-size: 30px;
  `};
`

const RequestAccessInfo = styled.div`
  // width: 260px;
  width: 310px;
  letter-spacing: 1px;
  font-size: 18px;
  color: white;
  text-align: center;
`

const RequestButton = styled(Button)`
  display: inline-block !important;
  margin-top: 1.5rem;
  position: relative;
  padding-left: 4rem !important;
  padding-right: 4rem !important;
  color: white !important;
  background: #ec6964 !important;
`

const LabelBaseC = ({ invalidMail, ...props }) => <LabelBase {...props} />
LabelBaseC.propTypes = {
  invalidMail: PropTypes.bool
}

const Label = styled(LabelBaseC)`
  color: ${props => (props.invalidMail ? 'red' : 'black')} !important;
`

const SuccessIcon = styled(MdCheck).attrs(props => ({
  color: theme('white')(props)
}))``

export {
  RequestAccessWrapper,
  RequestButton,
  RequestAccessTitle,
  RequestAccessInfo,
  Label,
  SuccessIcon
}
